import { createFileRoute } from '@tanstack/react-router';

import { getPresentationOptions } from '@/module/Author/Presentation';

export const Route = createFileRoute('/_auth/author/_author/presentation/_presentation/$presentationId/_layout')({
  loader: async ({ params: { presentationId }, context: { queryClient } }) => {
    const presentation = await queryClient.ensureQueryData(getPresentationOptions(presentationId));

    return {
      presentation,
      crumb: presentation.title,
    };
  },
});
